import { Link } from 'react-router';
import { Column } from 'react-table';

import { ExaminerDto } from 'api';
import { ExaminerStatusLabels } from 'components';

export const columns: Column<ExaminerDto>[] = [
  {
    Header: 'First Name',
    accessor: 'firstName',
    width: '100px',
    Cell: ({ value, row }) => <Link to={`/examiners/${row.original.id}`}>{value}</Link>,
  },
  {
    Header: 'Last Name',
    accessor: 'lastName',
    width: '100px',
    Cell: ({ value, row }) => <Link to={`/examiners/${row.original.id}`}>{value}</Link>,
  },
  {
    Header: 'Examiner Number',
    accessor: 'examinerNumber',
    width: '80px',
  },
  {
    Header: 'Main Speaking Centre',
    accessor: 'speakingMainCentreName',
  },
  {
    Header: 'Main Writing Centre',
    accessor: 'writingMainCentreName',
  },
  {
    Header: 'Main Life Skills Centre',
    accessor: 'lifeSkillsMainCentreName',
  },
  {
    Header: 'Status',
    accessor: 'certificationStatus',
    disableSortBy: true,
    Cell: (x) => <ExaminerStatusLabels examinerStatuses={x.value} />,
  },
];
